let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kuL94")).then(() => parcelRequire('b6HeC'));